/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ErrorHelper from 'app/mixins/ErrorHelper.jsx';

let _socialButtons = [
    {
        'link': '/options',
        'label': 'Post Options',
        fieldMappings: [
            'postTitle',
            'postBody',
            'postUrl',
            'postImages',
            'prefixText',
            'prefixSpace',
            'postfixText',
            'postfixSpace',
            'includeSummaryTitle',
            'includeSummaryBody',
            'thumbStyle',
            'thumbUrl',
            'numItems',
            'staticTitle',
            'name',
            'messageText'
        ]
    },
    {
        'link': '/links',
        'label': 'Links',
        fieldMappings: ['pdID', 'saID']
    },
    {
        'link': '/advanced',
        'label': 'Advanced',
        fieldMappings: [
            'postStyle',
            'postPrivacy',
            'autoSentiment',
            'postAsRetweet',
            'autoHash',
            'autoHashNum',
            'autoHashSpaces',
            'socialStats'
        ]
    }
];

class SocialConfigButtons {
    static getButtons(linkPrefix, activeTab) {
        let buttons = _.map(_socialButtons, _.clone),
            buttonSelected = false,
            re = null,
            constants = this.props.app.config.constants,
            hasAdvacnedTab = [
                constants.POST_SVC_STOCKTWITS,
                constants.POST_SVC_LINKEDIN,
                constants.POST_SVC_TWITTER
            ];

        // remove the helper panel for output modal display and pinterest
        if (_.isFunction(linkPrefix) || [constants.POST_SVC_PINTEREST, constants.POST_SVC_TIKTOK, constants.POST_SVC_YOUTUBE].indexOf(parseInt(this.state.social.psID)) >= 0) {
            buttons = [buttons[0], buttons[2]];
        }

        // nothing for advanced tab in a number of services
        if (hasAdvacnedTab.indexOf(this.state.social.psID) === -1) {
            buttons.pop();
        }

        for (let i = 0; i < buttons.length; ++i) {
            buttons[i].isActive = false;
            re = new RegExp(buttons[i].label, "i");

            if (re.test(this.props.router.location.pathname) || re.test(activeTab)) {
                buttons[i].isActive = true;
                buttonSelected = true;
            }
            if (this.state.errors !== null) {
                buttons[i].hasErrors = ErrorHelper.buttonHasError(this.props, buttons[i]);
            }
            if (_.isFunction(linkPrefix)) {
                buttons[i].handler = linkPrefix;
                buttons[i].data = buttons[i].link.replace("/", "");
            } else {
                buttons[i].link = linkPrefix + buttons[i].link;
            }

        }

        if (!buttonSelected) {
            buttons[0].isActive = true;
        }

        return buttons;

    }
}

export default SocialConfigButtons;
